import * as actions from 'actions'
import { fetchIfLoggedIn } from '../utils'

export const getDownloadableCLIpackage = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: actions.GET_DOWNLOADABLE_CLI_PACKAGES,
      method: 'get',
      path: '/downloads?artifact-type=cli',
    })
  )
}
